module.exports = __webpack_public_path__ + "media/images/icons/outlined/merge-cells-5ec2afe722f66004966fecdbf179292f.svg";